import './newsletter-signup.scss';

import AjaxLoad from './../../components/ajax-load/ajax-load';
import { createElementFromHTML } from '../../utilities/js/helper';

class NewsletterForm {
    constructor (element, options) {
        const settings = {
            loader: null,
            onSubmitted: null,
            content: element.querySelector('[data-newsletterform="content"]'),
            message: '[data-newsletterform="message"]',
            removeMessageButton: '[data-newsletterform="remove-message"]'
        };

        this.$element = element;
        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$element.addEventListener('submit', (e) => {
            this.submitForm();
            e.preventDefault();
        });
    }

    submitForm () {
        const $form = this.$element.querySelector('form');
        const formData = new FormData($form);

        if (this.settings.loader !== null) {
            const $loader = createElementFromHTML(this.settings.loader);
            $form.appendChild($loader);
        }

        new AjaxLoad($form.action, { // eslint-disable-line
            requestMethod: $form.method,
            requestData: formData,
            onSuccess: (resultText) => {
                const $result = createElementFromHTML(resultText);

                this.settings.content.innerHTML = '';

                if ($result) {
                    this.settings.content.appendChild($result);
                }

                if (this.$element.querySelectorAll(this.settings.message).length === 1) {
                    this.initMessage();
                }

                if (typeof this.settings.onSubmitted === 'function') {
                    this.settings.onSubmitted($result);
                }
            }
        });
    }

    initMessage () {
        const $message = this.$element.querySelector(this.settings.message);
        const $removeMessageButton = $message.querySelector(this.settings.removeMessageButton);

        if ($removeMessageButton && $message) {
            $removeMessageButton.addEventListener('click', (e) => {
                $message.remove();
                e.preventDefault();
            });
        }
    }
}

export { NewsletterForm };
